var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 36C8.0757 36 0 27.9252 0 18C0 8.0748 8.0757 0 18 0C27.9243 0 36 8.0757 36 18C36 27.9243 27.9243 36 18 36ZM18 1.026C8.6445 1.026 1.0368 8.6409 1.0368 18C1.0368 27.3591 8.6445 34.9722 17.9991 34.9722C27.3519 34.9722 34.9623 27.3591 34.9623 18C34.9623 8.6409 27.351 1.026 18 1.026Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8195 28.3469H14.0121C10.7334 28.3469 8.06671 25.682 8.06671 22.4096V13.5932C8.06671 10.3163 10.7343 7.65234 14.0121 7.65234H22.8195C26.0973 7.65234 28.7631 10.3163 28.7631 13.5932V22.4096C28.7631 25.682 26.0964 28.3469 22.8195 28.3469ZM14.0112 8.67834C11.304 8.67834 9.10351 10.8824 9.10351 13.5914V22.4078C9.10351 25.1177 11.3049 27.3236 14.0112 27.3236H22.8177C25.5231 27.3236 27.7245 25.1159 27.7245 22.4078V13.5914C27.7245 10.8824 25.5231 8.67834 22.8177 8.67834H14.0112Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.414 23.2515C15.5448 23.2515 13.2111 20.9169 13.2111 18.0513C13.212 15.1875 15.5457 12.8574 18.414 12.8574C21.2823 12.8574 23.616 15.1884 23.616 18.0522C23.6169 20.9178 21.2823 23.2515 18.414 23.2515ZM18.414 13.8825C16.1181 13.8825 14.2488 15.7536 14.2488 18.0549C14.2488 20.3544 16.1163 22.2255 18.414 22.2255C20.7099 22.2255 22.5783 20.3553 22.5783 18.0549C22.5783 15.7536 20.7117 13.8825 18.414 13.8825Z",
    fill: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1875 13.3179C23.9058 13.3179 23.6241 13.2036 23.4198 13.002C23.2191 12.8031 23.103 12.5232 23.103 12.2379C23.103 11.9571 23.2164 11.6799 23.4153 11.4801C23.8311 11.0688 24.552 11.0751 24.9552 11.4792C25.1559 11.6826 25.2702 11.958 25.2702 12.2379C25.2702 12.5214 25.1541 12.8004 24.9516 13.002C24.7509 13.2009 24.4719 13.3179 24.1875 13.3179Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.c60127bb9183c87710ad847e46ab575e.svg";
export { ForwardRef as ReactComponent };